import React, { useState } from "react";
import { Upload, Music, Link2 } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";
import { copyText } from "../../lib/clipboard";
import DirectUploadDialog from "../../components/DirectUploadDialog";

// Icon-only "Copia link upload" pill: copies the client's PERMANENT
// magic-link URL to the clipboard so staff can paste it anywhere.
export function UploadLinkButton({ clientId, clientName }) {
  const [busy, setBusy] = useState(false);
  const copyLink = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const { data } = await api.get(`/staff/clients/${clientId}/upload-link`);
      if (!data?.url) throw new Error("URL non disponibile");
      const ok = await copyText(data.url);
      if (ok) {
        toast.success(`Link upload di ${clientName} copiato ✓`);
      } else {
        window.prompt("Copia il link upload:", data.url);
      }
    } catch (e) {
      toast.error(apiError ? apiError(e) : String(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <button
      type="button"
      onClick={copyLink}
      disabled={busy}
      data-testid={`upload-link-copy-btn-${clientId}`}
      title={`Copia il link upload fisso di ${clientName} (sempre valido, nessun limite di dimensione)`}
      className="h-8 w-8 rounded-full bg-white text-[var(--mp-ink)] border-2 border-[var(--mp-ink)] grid place-items-center hover:bg-[var(--mp-yellow)] transition-colors disabled:opacity-50"
    >
      <Link2 className="h-3.5 w-3.5" />
    </button>
  );
}

// Icon-only "Carica video" pill that lives inside the client action bar.
export function DirectUploadButton({ clientId, clientName, onUploaded }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid={`direct-upload-btn-${clientId}`}
        title={`Carica un video direttamente per ${clientName} (salta produzione, va in Coda Metricool)`}
        className="h-8 w-8 rounded-full bg-[var(--mp-yellow)] text-[var(--mp-ink)] border-2 border-[var(--mp-ink)] grid place-items-center hover:bg-amber-300 transition-colors"
      >
        <Upload className="h-3.5 w-3.5" />
      </button>
      <DirectUploadDialog
        open={open}
        onOpenChange={setOpen}
        clientId={clientId}
        clientName={clientName}
        onUploaded={onUploaded}
      />
    </>
  );
}

// Icon-only "Carica musica" pill (reuses the same dialog in mode="musica").
export function MusicUploadButton({ clientId, clientName }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid={`music-upload-btn-${clientId}`}
        title={`Carica una traccia audio in /Clienti/${clientName}/Musica/`}
        className="h-8 w-8 rounded-full bg-white text-[var(--mp-ink)] border-2 border-[var(--mp-ink)] grid place-items-center hover:bg-[var(--mp-dash-bg)] transition-colors"
      >
        <Music className="h-3.5 w-3.5" />
      </button>
      <DirectUploadDialog
        open={open}
        onOpenChange={setOpen}
        clientId={clientId}
        clientName={clientName}
        mode="musica"
      />
    </>
  );
}
